export const HEADER_HEIGHT = 48;
export const xxxx = '你好';
